const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepozeGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3310_40260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.998 40H5.00184C2.24512 40 0 37.7456 0 35V5C0 2.24439 2.24512 0 5.00184 0H129.998C132.752 0 135 2.24439 135 5V35C135 37.7456 132.752 40 129.998 40Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.998 0.800499C132.31 0.800499 134.203 2.68828 134.203 5V35C134.203 37.3117 132.323 39.1995 129.998 39.1995H5.00184C2.68967 39.1995 0.797215 37.3117 0.797215 35V5C0.797215 2.68828 2.67725 0.800499 5.00184 0.800499C5.00184 0.800499 129.998 0.800499 129.998 0.800499ZM129.998 0H5.00184C2.24512 0 0 2.25436 0 5V35C0 37.7556 2.24512 40 5.00184 40H129.998C132.752 40 135 37.7556 135 35V5C135 2.25436 132.752 0 129.998 0Z",
    fill: "#A6A6A6",
    style: {
      fill: "#A6A6A6",
      fill: "color(display-p3 0.6510 0.6510 0.6510)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1183 13.2319C70.2168 13.2319 69.4569 12.9152 68.8558 12.2917C68.2598 11.6857 67.927 10.8503 67.9419 9.99745C67.9419 9.08722 68.2499 8.31665 68.8558 7.70568C69.4544 7.08223 70.2143 6.76553 71.1158 6.76553C72.0074 6.76553 72.7674 7.08223 73.3783 7.70568C73.9843 8.3366 74.2923 9.10717 74.2923 9.99745C74.2823 10.9102 73.9744 11.6807 73.3783 12.2892C72.7798 12.9176 72.0199 13.2319 71.1183 13.2319ZM44.2938 13.2319C43.4122 13.2319 42.6473 12.9201 42.0214 12.3042C41.4005 11.6907 41.0851 10.9152 41.0851 9.99994C41.0851 9.08473 41.4005 8.30917 42.0214 7.6957C42.6348 7.07974 43.3998 6.76802 44.2938 6.76802C44.7309 6.76802 45.1556 6.8553 45.5629 7.03236C45.9628 7.20443 46.2881 7.43884 46.529 7.72563L46.5886 7.79795L45.9156 8.46129L45.846 8.37899C45.4661 7.92513 44.9569 7.70318 44.2839 7.70318C43.6829 7.70318 43.1589 7.91765 42.7267 8.34159C42.2921 8.76802 42.0711 9.32662 42.0711 10.0024C42.0711 10.6782 42.2921 11.2368 42.7267 11.6633C43.1589 12.0872 43.6829 12.3017 44.2839 12.3017C44.9246 12.3017 45.4636 12.0872 45.8833 11.6633C46.1316 11.4139 46.2856 11.0648 46.3403 10.6234H44.1821V9.69071H47.2666L47.279 9.7755C47.3014 9.93261 47.3237 10.0947 47.3237 10.2443C47.3237 11.1047 47.0654 11.8004 46.5538 12.3142C45.9727 12.9226 45.2127 13.2319 44.2938 13.2319ZM79.9597 13.0997H79.0085L76.0953 8.41889L76.1201 9.26179V13.0972H75.1689V6.90019H76.2542L76.2841 6.94757L79.0234 11.3565L78.9985 10.5161V6.90019H79.9597V13.0997V13.0997ZM63.9708 13.0997H63.0072V7.83286H61.3357V6.90019H65.6397V7.83286H63.9683V13.0997H63.9708ZM60.551 13.0997H59.5898V6.90019H60.551V13.0997ZM55.1493 13.0997H54.1882V7.83286H52.5168V6.90019H56.8207V7.83286H55.1493V13.0997ZM51.9083 13.0897H48.2228V6.90019H51.9083V7.83286H49.1864V9.53361H51.6426V10.4563H49.1864V12.157H51.9083V13.0897ZM69.5612 11.6508C69.9908 12.0822 70.5124 12.2992 71.1183 12.2992C71.7417 12.2992 72.2508 12.0872 72.6755 11.6508C73.0977 11.2269 73.3113 10.6708 73.3113 9.99994C73.3113 9.32912 73.0977 8.77051 72.678 8.34907C72.2483 7.91765 71.7243 7.70069 71.1208 7.70069C70.4974 7.70069 69.9883 7.91266 69.5661 8.34907C69.1439 8.77301 68.9303 9.32912 68.9303 9.99994C68.9303 10.6708 69.1414 11.2294 69.5612 11.6508Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8526 21.7556C65.5056 21.7556 63.6032 23.5436 63.6032 26.01C63.6032 28.4539 65.5181 30.2643 67.8526 30.2643C70.1995 30.2643 72.1019 28.4638 72.1019 26.01C72.1019 23.5436 70.1995 21.7556 67.8526 21.7556ZM67.8526 28.5786C66.5686 28.5786 65.4634 27.5112 65.4634 26C65.4634 24.4663 66.5711 23.4214 67.8526 23.4214C69.1366 23.4214 70.2417 24.4663 70.2417 26C70.2442 27.5212 69.1366 28.5786 67.8526 28.5786ZM58.5815 21.7556C56.2346 21.7556 54.3322 23.5436 54.3322 26.01C54.3322 28.4539 56.247 30.2643 58.5815 30.2643C60.9285 30.2643 62.8309 28.4638 62.8309 26.01C62.8309 23.5436 60.926 21.7556 58.5815 21.7556ZM58.5815 28.5786C57.2975 28.5786 56.1924 27.5112 56.1924 26C56.1924 24.4663 57.3 23.4214 58.5815 23.4214C59.8655 23.4214 60.9707 24.4663 60.9707 26C60.9707 27.5212 59.8655 28.5786 58.5815 28.5786ZM47.5497 23.0549V24.8554H51.8536C51.722 25.8653 51.3892 26.611 50.8801 27.1222C50.2493 27.7556 49.2757 28.4439 47.5596 28.4439C44.9146 28.4439 42.8458 26.2993 42.8458 23.6434C42.8458 20.9875 44.9146 18.8429 47.5596 18.8429C48.9876 18.8429 50.0282 19.409 50.8006 20.1322L52.0722 18.8554C50.9993 17.8229 49.5713 17.0324 47.5695 17.0324C43.9411 17.0324 40.8963 20 40.8963 23.6334C40.8963 27.2768 43.9386 30.2344 47.5695 30.2344C49.529 30.2344 50.9993 29.591 52.1616 28.3791C53.3462 27.1895 53.7212 25.5112 53.7212 24.1571C53.7212 23.7357 53.689 23.3566 53.6219 23.0349H47.5472C47.5497 23.0324 47.5497 23.0549 47.5497 23.0549ZM92.6731 24.4564C92.3179 23.5012 91.245 21.7456 89.0446 21.7456C86.8641 21.7456 85.0511 23.4688 85.0511 26C85.0511 28.389 86.8442 30.2544 89.2557 30.2544C91.1929 30.2544 92.3204 29.0648 92.7848 28.3666L91.3469 27.399C90.87 28.1097 90.2069 28.5761 89.2656 28.5761C88.3145 28.5761 87.6489 28.1421 87.2068 27.2868L92.8717 24.9302C92.8717 24.9327 92.6731 24.4564 92.6731 24.4564ZM86.8963 25.8778C86.8516 24.2344 88.1679 23.399 89.1092 23.399C89.8518 23.399 90.4702 23.7656 90.6813 24.2993L86.8963 25.8778ZM82.2944 30H84.1545V17.5012H82.2944V30ZM79.2396 22.7007H79.1725C78.7528 22.1995 77.9556 21.7456 76.9374 21.7456C74.8239 21.7456 72.8768 23.6135 72.8768 26.0125C72.8768 28.4015 74.8139 30.2469 76.9374 30.2469C77.9432 30.2469 78.7528 29.7905 79.1725 29.2793H79.2396V29.8903C79.2396 31.5137 78.3753 32.389 76.9821 32.389C75.8421 32.389 75.1343 31.5661 74.8462 30.8778L73.2294 31.5561C73.6939 32.6783 74.9331 34.0673 76.9796 34.0673C79.1601 34.0673 81.0079 32.7781 81.0079 29.6334V22H79.2495V22.7007C79.252 22.7007 79.2396 22.7007 79.2396 22.7007ZM77.1038 28.5786C75.8198 28.5786 74.7469 27.5012 74.7469 26.0125C74.7469 24.5112 75.8198 23.4239 77.1038 23.4239C78.3753 23.4239 79.3613 24.5237 79.3613 26.0125C79.3737 27.5012 78.3778 28.5786 77.1038 28.5786ZM101.383 17.5012H96.9348V30H98.795V25.2668H101.385C103.444 25.2668 105.468 23.7681 105.468 21.389C105.468 19.01 103.452 17.5012 101.383 17.5012ZM101.437 23.5212H98.7925V19.2319H101.437C102.831 19.2319 103.618 20.3865 103.618 21.3766C103.618 22.3566 102.821 23.5212 101.437 23.5212ZM112.924 21.7332C111.573 21.7332 110.18 22.3342 109.603 23.6434L111.252 24.3317C111.608 23.6434 112.258 23.409 112.946 23.409C113.91 23.409 114.883 23.9875 114.906 25.0199V25.1521C114.573 24.9626 113.843 24.6733 112.969 24.6733C111.188 24.6733 109.382 25.6509 109.382 27.4838C109.382 29.1621 110.843 30.2394 112.469 30.2394C113.719 30.2394 114.407 29.6733 114.836 29.0175H114.903V29.985H116.696V25.197C116.696 22.9676 115.047 21.7332 112.924 21.7332ZM112.69 28.5786C112.082 28.5786 111.23 28.2793 111.23 27.5112C111.23 26.5436 112.293 26.1771 113.2 26.1771C114.019 26.1771 114.407 26.3541 114.893 26.5985C114.759 27.7207 113.815 28.5686 112.69 28.5786ZM123.238 22L121.102 27.4214H121.035L118.822 22H116.82L120.141 29.5786L118.249 33.7905H120.186L125.294 22H123.238ZM106.494 30H108.354V17.5012H106.494V30Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3911 7.53364C10.103 7.84536 9.93665 8.32167 9.93665 8.94511V31.0573C9.93665 31.6808 10.103 32.1571 10.4011 32.4563L10.4781 32.5237L22.8163 20.1346V19.8578L10.4681 7.4663L10.3911 7.53364Z",
    fill: "url(#paint0_linear_3310_40260)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9214 24.2768L22.8062 20.1446V19.8554L26.9214 15.7232L27.0108 15.7781L31.8786 18.5561C33.2719 19.3441 33.2719 20.6459 31.8786 21.4439L27.0108 24.2219L26.9214 24.2768Z",
    fill: "url(#paint1_linear_3310_40260)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0109 24.2219L22.8063 20L10.3911 32.4663C10.8456 32.9551 11.608 33.01 12.4599 32.5337L27.0109 24.2219Z",
    fill: "url(#paint2_linear_3310_40260)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0109 15.7781L12.4599 7.4788C11.608 6.99002 10.8431 7.05736 10.3911 7.54613L22.8063 20L27.0109 15.7781Z",
    fill: "url(#paint3_linear_3310_40260)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9215 24.1322L12.4698 32.3766C11.6626 32.8429 10.9424 32.8105 10.4779 32.3866L10.401 32.4639L10.4779 32.5312C10.9424 32.9526 11.6626 32.9876 12.4698 32.5212L27.0209 24.222L26.9215 24.1322Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8787 21.2993L26.9091 24.1322L26.9985 24.2219L31.8662 21.4439C32.5641 21.0449 32.9068 20.5212 32.9068 20C32.8646 20.4788 32.5095 20.9327 31.8787 21.2993Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4599 7.62347L31.8787 18.7008C32.5095 19.0574 32.8646 19.5237 32.9193 20C32.9193 19.4788 32.5766 18.9551 31.8787 18.5561L12.4599 7.47883C11.0667 6.67833 9.93665 7.34666 9.93665 8.94517V9.08981C9.93665 7.48881 11.0667 6.83295 12.4599 7.62347Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3310_40260",
    x1: 21.7096,
    y1: 8.70654,
    x2: 1.93515,
    y2: 13.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    style: {
      stopColor: "#00A0FF",
      stopColor: "color(display-p3 0.0000 0.6275 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF",
    style: {
      stopColor: "#00A1FF",
      stopColor: "color(display-p3 0.0000 0.6314 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF",
    style: {
      stopColor: "#00BEFF",
      stopColor: "color(display-p3 0.0000 0.7451 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF",
    style: {
      stopColor: "#00D2FF",
      stopColor: "color(display-p3 0.0000 0.8235 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF",
    style: {
      stopColor: "#00DFFF",
      stopColor: "color(display-p3 0.0000 0.8745 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF",
    style: {
      stopColor: "#00E3FF",
      stopColor: "color(display-p3 0.0000 0.8902 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3310_40260",
    x1: 33.6955,
    y1: 20,
    x2: 9.5978,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    style: {
      stopColor: "#FFE000",
      stopColor: "color(display-p3 1.0000 0.8784 0.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00",
    style: {
      stopColor: "#FFBD00",
      stopColor: "color(display-p3 1.0000 0.7412 0.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500",
    style: {
      stopColor: "#FFA500",
      stopColor: "color(display-p3 1.0000 0.6471 0.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00",
    style: {
      stopColor: "#FF9C00",
      stopColor: "color(display-p3 1.0000 0.6118 0.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3310_40260",
    x1: 24.7246,
    y1: 22.2973,
    x2: 8.76182,
    y2: 49.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    style: {
      stopColor: "#FF3A44",
      stopColor: "color(display-p3 1.0000 0.2275 0.2667)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162",
    style: {
      stopColor: "#C31162",
      stopColor: "color(display-p3 0.7647 0.0667 0.3843)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3310_40260",
    x1: 7.2648,
    y1: 0.178792,
    x2: 14.3865,
    y2: 12.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    style: {
      stopColor: "#32A071",
      stopColor: "color(display-p3 0.1961 0.6275 0.4431)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771",
    style: {
      stopColor: "#2DA771",
      stopColor: "color(display-p3 0.1765 0.6549 0.4431)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74",
    style: {
      stopColor: "#15CF74",
      stopColor: "color(display-p3 0.0824 0.8118 0.4549)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775",
    style: {
      stopColor: "#06E775",
      stopColor: "color(display-p3 0.0235 0.9059 0.4588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076",
    style: {
      stopColor: "#00F076",
      stopColor: "color(display-p3 0.0000 0.9412 0.4627)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3310_40260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeGooglePlay);
export default __webpack_public_path__ + "static/media/Repoze-GooglePlay.2588c54241438f9660c5a69318532635.svg";
export { ForwardRef as ReactComponent };